import $ from '../../../../js/alias/jquery'
import ModalAlert from '../../../../js/components/modalAlert/ModalAlert'
import messageResource from '../../../../js/messageResource'
import {ModalAlertPointerPosition} from '../../../../js/components/modalAlert/constants'
import View from '../../../../js/View'
import {connect} from '../../../../js/redux/utils'
import {copyLink} from '../actions'
import {bindActionCreators} from 'redux'

class ICalCopyDialog extends View {
    constructor({
        copyLink = () => {},
    }) {
        super()

        this.state = {
            linkForCopy: '',
        }

        this.actions = {
            copyLink,
        }
    }

    afterRender() {
        this.modalAlert = new ModalAlert({
            showCancelButton: true,
            okButtonLabel: messageResource.getMessage('icalendar.dialog.copy.ok'),
            returnToInitialPosition: false,
            onConfirm: () => this.actions.copyLink(this.state.linkForCopy),
        }).init($('body'))

        this.modalAlert.setState({
            text: messageResource.getMessage('icalendar.dialog.copy.content'),
            additionalClass: 'iCalCopyDialog',
            pointerPosition: ModalAlertPointerPosition.RIGHT,
            offsets: {
                left: 93,
                top: 0,
            },
        })
    }

    showAt(element, onHideCb) {
        this.modalAlert.showAt(element, onHideCb)
    }
}

const ICalCopyDialogConnected = connect(
    state => ({}),
    dispatch => ({
        copyLink: bindActionCreators(copyLink, dispatch),
    })
)(ICalCopyDialog)

let instance = null
export const getCopyDialog = () => {
    if (!instance) {
        instance = new ICalCopyDialogConnected().init()
    }
    return instance
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/dialogs/CopyLinkDialog.js